module.exports = __webpack_public_path__ + "img/eye.7585229c.svg";